import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import {
  EditCardRequest,
  GlobalSearchCardsItem,
  GlobalSearchCardsResponse,
} from "tng-address-collection-shared/types/apiTypes.ts";
import {
  getSenderDisplayName,
  getSenderSignature,
  withSenderSignature,
} from "./getSenderSignature.ts";
import { queryKeys } from "./queryKeys.ts";

export const useEditCardGlobalSearchCache = () => {
  const queryClient = useQueryClient();

  return useCallback(
    (newCard: EditCardRequest) => {
      queryClient.setQueriesData<GlobalSearchCardsResponse>(
        { queryKey: queryKeys.globalSearchCardsAllResults() },
        (old) => {
          const oldCard = old?.cards.find((card) => card.id === newCard.id);
          const senderSignature = getSenderSignature(
            queryClient,
            newCard.senderId,
          );
          const senderDisplayName = getSenderDisplayName(
            queryClient,
            newCard.senderId,
          );
          const tempCard: GlobalSearchCardsItem = {
            id: newCard.id,
            projectId: newCard.projectId,
            firstName: newCard.recipient.firstName,
            lastName: newCard.recipient.lastName,
            companyName: newCard.recipient.companyName,
            departmentName: newCard.departmentName,
            senderId: newCard.senderId,
            senderDisplayName,
            manualDispatch: newCard.manualDispatch,
            email: newCard.recipient.email,
            comment: newCard.comment,
            signatures: withSenderSignature(
              oldCard?.signatures ?? [],
              senderSignature,
            ),
            language: newCard.recipient.preferredLanguage,
            title: newCard.recipient.title,
            salutation: newCard.recipient.salutationKind,
            receivesGift: newCard.receivesGift,
            formality: newCard.formality,
            projectDisplayName: oldCard?.projectDisplayName,
          };

          const updatedResponse: GlobalSearchCardsResponse = {
            cards: [
              tempCard,
              ...(old?.cards.filter((card) => card.id !== newCard.id) || []),
            ],
            hasMore: old?.hasMore || false,
          };
          return updatedResponse;
        },
      );
    },
    [queryClient],
  );
};
